/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import { connect } from 'react-redux';
import { selectModelHasRun } from '#selectors/entities/models.js';
import SiteCoordinatesSection from './index.jsx';

const mapStateToProps = (state, ownProps) => {
  const { modelId } = ownProps;
  return {
    isReadOnly: selectModelHasRun(state, { modelId }),
  };
};

export default connect(mapStateToProps)(SiteCoordinatesSection);
